import { useTranslations } from 'next-intl'

import IconClose from 'asset/icon/close.svg'
import IconCommunity from 'asset/icon/home/us_s.svg'
import IconSearch from 'asset/icon/search.svg'
import Headshot from 'component/block/headshot'
import SearchItem from 'component/page/search/dropdown-card/search-item'
import { Button } from 'component/ui/button'
import { HeadshotSize } from 'constant'
import { useRecentSearchStore } from 'store/recent-search'
import { type ISearchHistoryV2 } from 'type/search'

interface IRecentItem {
  item: ISearchHistoryV2
}
const RecentItem = (props: IRecentItem) => {
  const { item } = props
  const t = useTranslations()
  const removeSearch = useRecentSearchStore(state => state.removeSearch)

  const handleRemove = (e: any) => {
    e.stopPropagation()
    // prevent anchor tag from redirecting
    e.preventDefault()
    removeSearch(item.id, item.type)
  }

  if (item.type === 'user') {
    return (
      <SearchItem
        title={item.name}
        description={`@${item.uid}`}
        prefix={<Headshot size={HeadshotSize.md} src={item.image} />}
        suffix={
          <Button
            $variant='text'
            $size='sm'
            $icon
            className='m-[4px]'
            onClick={handleRemove}
          >
            <IconClose className='h-[15px] w-[15px]' />
          </Button>
        }
      />
    )
  }

  if (item.type === 'community') {
    return (
      <SearchItem
        title={item.title}
        description={t('community.count_join_members', {
          members: item.count
        })}
        iconShape='square'
        prefix={
          <Headshot
            size={HeadshotSize.md}
            src={item.image}
            rounded={false}
            fallback={<IconCommunity className='sq-[24px]' />}
          />
        }
        suffix={
          <Button
            $variant='text'
            $size='sm'
            $icon
            className='m-[4px]'
            onClick={handleRemove}
          >
            <IconClose className='h-[15px] w-[15px]' />
          </Button>
        }
      />
    )
  }
  if (item.type === 'keyword') {
    return (
      <SearchItem
        title={item.keyword}
        prefix={<IconSearch className='h-[18px] w-[18px] fill-label-l1' />}
        suffix={
          <Button
            $variant='text'
            $size='sm'
            $icon
            className='m-[4px]'
            onClick={handleRemove}
          >
            <IconClose className='h-[15px] w-[15px]' />
          </Button>
        }
      />
    )
  }

  return null
}

export default RecentItem
